"use client";

/**
 * PostDetailRichText 컴포넌트
 * @description 마크다운 본문. 렌더는 공용 `Markdown`(react-markdown + GFM, raw HTML 차단)이
 *   맡고, 조판은 `.fw-prose` + `.fw-prose-magazine`(globals.css)이 태그 선택자로 입힌다 —
 *   첫 글자 드롭캡 · 발췌문 크게 · 그림은 글줄보다 넓게. 블록들은 화면에 들어올 때 하나씩
 *   떠오른다(`useProseReveal`). 앱 `PostDetailRichText` 의 웹 대응.
 */
import { memo } from "react";

import { useProseReveal } from "@/shared/ui";
import { Markdown } from "@/shared/ui/markdown";

const PostDetailRichText = memo<{ content: string }>(({ content }) => {
  const ref = useProseReveal<HTMLDivElement>();
  return (
    <div ref={ref} className="fw-prose fw-prose-magazine">
      <Markdown>{content}</Markdown>
    </div>
  );
});

PostDetailRichText.displayName = "PostDetailRichText";

export default PostDetailRichText;
